import { Course, ChatMessage, User } from '../types';

export const mockCourses: Course[] = [
  {
    id: 1,
    title: "Управление стрессом и тревожностью",
    description: "Научитесь эффективно справляться со стрессом и тревожностью в повседневной жизни",
    price: 2999,
    duration: "8 недель",
    lessons: 24,
    image: "/images/stress-management.jpg",
    rating: 4.8,
    instructor: "Анна Петрова",
    category: "Стресс-менеджмент"
  },
  {
    id: 2,
    title: "Улучшение самооценки",
    description: "Практический курс по повышению уверенности в себе и развитию здоровой самооценки",
    price: 2499,
    duration: "6 недель",
    lessons: 18,
    image: "/images/self-esteem.jpg",
    rating: 4.9,
    instructor: "Михаил Иванов",
    category: "Личностный рост"
  },
  {
    id: 3,
    title: "Эффективное общение",
    description: "Научитесь выстраивать здоровые отношения и эффективно коммуницировать с окружающими",
    price: 1999,
    duration: "4 недели",
    lessons: 12,
    image: "/images/communication.jpg",
    rating: 4.7,
    instructor: "Елена Сидорова",
    category: "Коммуникации"
  }
];

export const mockChatMessages: ChatMessage[] = [
  {
    id: 1,
    text: "Здравствуйте! Я ваш AI-психолог. Как я могу вам помочь сегодня?",
    sender: "ai",
    timestamp: "2024-03-20T10:00:00Z"
  },
  {
    id: 2,
    text: "Я чувствую постоянную тревогу и не могу сконцентрироваться на работе",
    sender: "user",
    timestamp: "2024-03-20T10:01:00Z"
  },
  {
    id: 3,
    text: "Я понимаю ваши чувства. Давайте разберем ситуацию подробнее. Когда вы впервые заметили эти симптомы?",
    sender: "ai",
    timestamp: "2024-03-20T10:02:00Z"
  }
];

export const mockUser: User = {
  id: 1,
  name: "Иван Иванов",
  email: "ivan@example.com",
  avatar: "/images/avatar.jpg",
  subscription: {
    type: "free",
    expiresAt: "2024-04-20T00:00:00Z"
  }
}; 